import React from 'react';
import ScreenWrapper from '../features/Theme/ScreenWrapper';
import CopyTradingAgreement from '../features/CopyTrading/CopyTradingAgreement';
import { goBack } from '~/navigation';
import { isDesktop } from '~/constants/scale';

type Props = {
    setActiveRightTab?: Function;
};

export default function CopyTradingAgreementScreen({ setActiveRightTab }: Props) {
    const onClose = () => {
        if (isDesktop() && setActiveRightTab) {
            setActiveRightTab('legal-documents');
        } else {
            goBack();
        }
    };
    return (
        <ScreenWrapper>
            <CopyTradingAgreement setAgreement={onClose} setActiveRightTab={setActiveRightTab} />
        </ScreenWrapper>
    );
}
